<template>
  <div class="proto">
    <v-touch @tap="flashTip">
      <div class="proto_main" :style="protoImg">
        <!-- 用于播放转场动画的底图 -->
        <div class="animate_img" v-show="hasAnimate" ref="lastImg">
          <img :src="lastImg" @error="onImgError(lastImg)" />
          <div class="header-img" v-if="lastLayoutData" :style="lastHeaderStyle">
            <img :src="lastImg" @error="onImgError(lastImg)" />
          </div>
          <div class="footer" v-if="showFoot && shareType === 'proto'">
            <div class="footer-img" v-if="lastLayoutData" :style="lastFooterStyle">
              <img :src="lastImg" @error="onImgError(lastImg)" />
            </div>
          </div>
        </div>
        <img :src="imageSrc" id="proto_img" ref="protoImg" @error="onImgError(imageSrc)" />

        <div class="hotspots" v-if="shareType === 'proto'">
          <v-touch
            class="hotsports_box"
            @tap="goTo(item, index)"
            v-for="(item, index) in hotspots"
            :key="index"
          >
            <div
              class="rect"
              :class="{ active: flashing }"
              :style="{
                left: item.p_x * 100 + '%',
                top: item.p_y * 100 + '%',
                width: item.p_w * 100 + '%',
                height: item.p_h * 100 + '%',
              }"
            ></div>
          </v-touch>
        </div>
        <!-- 原型的固定顶部 -->
        <div class="header" v-if="showHead && shareType === 'proto'">
          <div class="header-img" v-if="layoutData" :style="headerStyle">
            <img :src="imageSrc" alt="原型固定的顶部" :style="fixedAnimate" ref="head" @error="onImgError(imageSrc)" />
            <div class="hotspots-header" :style="hotsportsHeight">
              <v-touch
                class="hotsports_box"
                @tap="goTo(item, index)"
                v-for="(item, index) in hotspots"
                :key="index"
              >
                <div
                  class="rect"
                  :class="{ active: flashing }"
                  :style="{
                    left: item.p_x * 100 + '%',
                    top: item.p_y * 100 + '%',
                    width: item.p_w * 100 + '%',
                    height: item.p_h * 100 + '%',
                  }"
                ></div>
              </v-touch>
            </div>
          </div>
        </div>
        <!-- 原型的固定底部 -->
        <div class="footer" v-if="showFoot && shareType === 'proto'">
          <div class="footer-img" v-if="layoutData" :style="footerStyle">
            <img :src="imageSrc" alt="原型固定的底部" :style="fixedAnimate" ref="foot" @error="onImgError(imageSrc)" />
            <div class="hotspots-footer" :style="hotsportsHeight">
              <v-touch
                class="hotsports_box"
                @tap="goTo(item, index)"
                v-for="(item, index) in hotspots"
                :key="index"
              >
                <div
                  class="rect"
                  :class="{ active: flashing }"
                  :style="{
                    left: item.p_x * 100 + '%',
                    top: item.p_y * 100 + '%',
                    width: item.p_w * 100 + '%',
                    height: item.p_h * 100 + '%',
                  }"
                ></div>
              </v-touch>
            </div>
          </div>
        </div>
      </div>
    </v-touch>
  </div>
</template>

<script>
import Method from '../../../common/js/global/method.js';

export default {
  name: 'ProtoItem',
  props: {
    shareType: {
      type: String,
      default: "proto",
    },
    //原型主页id，用于传值给分享组件
    homeId: {
      type: String,
      default: "",
    },
    pageShare: {
      type: Boolean,
      default: true,
    },
    //控制固定顶部的显示隐藏
    showHead: {
      type: Boolean,
      default: false,
    },
    //控制固定底部的显示隐藏
    showFoot: {
      type: Boolean,
      default: false,
    },
    imageSrc: "",
    imgHeight: 0,
    //固定顶部底部的高度信息
    layoutData: {
      type: Object,
      default: null,
    },
    hotspots: {
      default() {
        return [
          {
            next_image: "",
            p_h: 0.136935009360792,
            p_w: 0.388758782201405,
            p_x: 0.233021077283372,
            p_y: 0.273870018721583,
          },
        ];
      },
    },
  },
  data() {
    return {
      flashing: false,
      protoImg: "",
      //记录上一原型页面的固定信息，用于动画操作
      lastImg: "",
      lastLayoutData: null,
      lastHeaderStyle: "",
      lastFooterStyle: "",
      // 动画相关的控制属性
      hasAnimate: false,
      animationType: null,
      goback: false,
      banSliderbarGoBackanimate: false,
    };
  },
  watch: {
    //监听imageSrc改变，生成转场动画
    imageSrc: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue && oldValue) {
          // 不是第一张图并且是已经切换的图
          // 获取要移动的图片
          let protoImgStyle = this.$refs["protoImg"].style;
          let lastImgStyle = this.$refs["lastImg"].style;
          // 如果goback标志为true，则启动退出动画
          if (this.goback) {
            // 清除初始化动画
            protoImgStyle.transition = "all 0s linear";
            // 动画图片位置初始化
            if (this.animationType === "slideFromRight") {
              protoImgStyle.transform = "translateX(-40%)";
            } else if (this.animationType === "slideFromLeft") {
              protoImgStyle.transform = "translateX(40%)";
            }

            this.hasAnimate = true; //退场图出现
            lastImgStyle.zIndex = "9999"; //将退出图置顶
            lastImgStyle.height = "100vh";
            lastImgStyle.transform = "translate3d(0,0,0)"; //退场图位置

            setTimeout(() => {
              if (this.showHead) {
                var headStyle = this.$refs["head"].style;
              }
              if (this.showFoot) {
                var footStyle = this.$refs["foot"].style;
              }
              lastImgStyle.transition = "all 0.25s ease";
              //根据数据方向退场
              if (this.animationType === "slideFromRight") {
                lastImgStyle.transform = "translateX(100%)";
              } else if (this.animationType === "slideFromLeft") {
                lastImgStyle.transform = "translateX(-100%)";
              } else if (this.animationType === "slideFromTop") {
                lastImgStyle.transform = `translateY(-${this.$root.device.size.height}px)`;
              } else if (this.animationType === "slideFromBottom") {
                lastImgStyle.transform = `translateY(${this.$root.device.size.height}px)`;
              }

              //动画开始
              //将动画添加到异步队列，防止动画失效
              setTimeout(() => {
                protoImgStyle.transition = "all 0.25s ease";
                protoImgStyle.transform = "translate3d(0,0,0)";
                if (headStyle) {
                  headStyle.transform = "translate3d(0,0,0)";
                }
                if (footStyle) {
                  footStyle.transform = "translate3d(0,0,0)";
                }
              }, 20);
            }, 0);

            setTimeout(() => {
              this.hasAnimate = false;
              this.goback = false;
              this.animationType = null;
              lastImgStyle.zIndex = "0";
            }, 300);
          }
          //进场动画
          else {
            if (this.banSliderbarGoBackanimate) return;
            // 清除初始化动画
            protoImgStyle.zIndex = "999";
            protoImgStyle.transition = "all 0s linear";
            // 动画图片位置初始化
            if (this.animationType === "slideFromRight") {
              protoImgStyle.transform = "translateX(100%)";
            } else if (this.animationType === "slideFromLeft") {
              protoImgStyle.transform = "translateX(-100%)";
            } else if (this.animationType === "slideFromTop") {
              protoImgStyle.transform = `translateY(-${this.$root.device.size.height}px)`;
            } else if (this.animationType === "slideFromBottom") {
              protoImgStyle.transform = `translateY(${this.$root.device.size.height}px)`;
            } else {
              return;
            }

            this.hasAnimate = true;

            setTimeout(() => {
              protoImgStyle.transition = "all 0.25s ease";
              protoImgStyle.transform = "translate3d(0,0,0)";
              lastImgStyle.transition = "all 0.75s ease";

              if (this.animationType === "slideFromRight") {
                lastImgStyle.transform = "translateX(-100%)";
              } else if (this.animationType === "slideFromLeft") {
                lastImgStyle.transform = "translateX(100%)";
              } else {
                return;
              }
            }, 20);

            setTimeout(() => {
              this.hasAnimate = false;
              protoImgStyle.zIndex = "0";
            }, 300);
          }
        }
      },
    },
    hasAnimate(value) {
      if (!value) {
        let lastImgStyle = this.$refs["lastImg"].style;
        if (this.showHead) {
          var headStyle = this.$refs["head"].style;
        }
        if (this.showFoot) {
          var footStyle = this.$refs["foot"].style;
        }
        //动画结束后图片位置重置
        lastImgStyle.transition = "all 0s linear";
        lastImgStyle.transform = "translate3d(0,0,0)";
      }
    },
  },
  computed: {
    //固定样式初始化
    fixedAnimate() {
      if (this.goback) {
        if (this.animationType === "slideFromRight") {
          return { transform: "translateX(-40%)" };
        } else if (this.animationType === "slideFromLeft") {
          return { transform: "translateX(40%)" };
        } else if (this.animationType === "slideFromTop") {
          return { transform: `translateY(${this.$root.device.size.height}px)` };
        } else if (this.animationType === "slideFromBottom") {
          return { transform: `translateY(-${this.$root.device.size.height}px)` };
        }
      }
    },
    hotsportsHeight() {
      return `height: ${this.imgHeight}px`;
    },
    headerStyle() {
      if (this.layoutData.scrollInfo && this.layoutData.scrollInfo.topOffset) {
        let viewportWidth = 0;
        if (this.layoutData.scrollInfo.artboardWidth) {
          viewportWidth = this.layoutData.scrollInfo.artboardWidth;
        } else {
          viewportWidth = this.layoutData.scrollInfo.viewportWidth;
        }
        return `height: ${
          (this.layoutData.scrollInfo.topOffset * 18.75) / viewportWidth
        }rem`;
      } else {
        return "height: 0";
      }
    },
    footerStyle() {
      if (this.layoutData.scrollInfo && this.layoutData.scrollInfo.bottomOffset) {
        let viewportWidth;
        if (this.layoutData.scrollInfo.artboardWidth) {
          viewportWidth = this.layoutData.scrollInfo.artboardWidth;
        } else {
          viewportWidth = this.layoutData.scrollInfo.viewportWidth;
        }
        return `height: ${
          (this.layoutData.scrollInfo.bottomOffset * 18.75) / viewportWidth
        }rem`;
      } else {
        return "height: 0";
      }
    },
  },
  mounted() {
    if (window.isWebview) {
      console.log("[解锁屏幕方向]");
      screen.orientation.unlock();
    }
    if (window.system === "ios") {
      this.$refs.protoImg.addEventListener("load", () => {
        this.$nextTick(() => {
          this.protoImg = "width: 18.749rem";
          setTimeout(() => {
            this.protoImg = "width: 18.75rem";
          }, 200);
        });
      });
    }
  },
  destroyed() {
    if (window.isWebview) {
      screen.orientation.lock("portrait");
      setTimeout(() => {
        StatusBar.show();
      }, 300);
    }
  },
  methods: {
    onImgError(imgSrc) {
      if (!imgSrc) {
        return;
      }
      if (!imgSrc.includes('?')) {
        console.error('original image load error');
        return;
      }
      const format = 'image/format,jpg';
      const baseImageSrc = imgSrc.split('?')[0];
      const image = document.querySelector(`[src="${imgSrc}"]`);
      if (imgSrc.includes(format)) {
        image.src = baseImageSrc;
        return;
      }

      const newImageSrc = Method.handleImg(baseImageSrc, {
        ali: `?x-oss-process=${format}`,
      });
      image.src = newImageSrc;
    },
    //热区高亮提示
    flashTip(e) {
      if (!e.target.className.includes("rect") && !this.flashing) {
        this.flashing = true;
        setTimeout(() => {
          this.flashing = false;
        }, 800);
      }
    },
    //原型跳转
    goTo(item, index) {
      this.lastImg = this.imageSrc;
      this.lastLayoutData = this.layoutData;
      this.lastFooterStyle = this.footerStyle;
      this.lastHeaderStyle = this.headerStyle;
      if (item.next_image == "return") {
        this.$router.go(-1);
        this.goback = true;
        this.banSliderbarGoBackanimate = false;
      } else {
        console.log("[打印点击的热区动画类型：]", this.hotspots[index].animation_type);
        this.animationType = this.hotspots[index].animation_type;
        this.goback = false;
        this.banSliderbarGoBackanimate = false;

        //如果是预览分享链接的原型，走share组件
        if (this.pageShare) {
          this.$router.push({
            name: "share",
            query: {
              id: item.next_image,
              team_id: this.$route.query.team_id,
              home_id: localStorage.homeId,
            },
          });
        } else {
          this.$router.push({
            name: "proto",
            query: {
              image_id: item.next_image,
              project_id: this.$route.query.project_id,
              project_name: this.$route.query.project_name,
            },
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.proto {
  height: 100%;
  .proto_main {
    width: 100%;
    position: relative;
    .animate_img {
      width: 100%;
      position: absolute;
      .header-img {
        top: 0;
        left: 0;
        position: fixed;
        overflow: hidden;
      }
      .footer {
        bottom: 0;
        left: 0;
        .footer-img {
          position: relative;
          img {
            position: absolute;
            bottom: 0;
          }
        }
      }
    }
    .header,
    .footer {
      width: 100%;
      position: fixed;
      overflow: hidden;
      z-index: 99;
    }
    .header {
      top: 0;
      left: 0;
      .header-img {
        position: relative;
        img {
          transition: transform 0.25s ease;
        }
        .hotspots-header {
          position: absolute;
          top: 0;
          width: 100%;
          .hotsports_box {
            width: 100%;
          }
          .rect {
            opacity: 0;
            position: absolute;
            background: rgba(40, 120, 255, 0.4);
            border-radius: 0.1rem;
            &.active {
              animation: flashing 0.8s ease;
            }
          }
        }
      }
    }
    .footer {
      bottom: 0;
      left: 0;
      .footer-img {
        position: relative;
        img {
          position: absolute;
          bottom: 0;
          transition: transform 0.25s ease;
        }
        .hotspots-footer {
          position: absolute;
          bottom: 0;
          width: 100%;
          .hotsports_box {
            width: 100%;
          }
          .rect {
            opacity: 0;
            position: absolute;
            background: rgba(40, 120, 255, 0.4);
            border-radius: 0.1rem;
            &.active {
              animation: flashing 0.8s ease;
            }
          }
        }
      }
    }
    img {
      width: 100%;
      display: block;
    }
    .hotspots {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      overflow: hidden;
      .hotsports_box {
        width: 100%;
      }
      .rect {
        opacity: 0;
        position: absolute;
        background: rgba(40, 120, 255, 0.4);
        border-radius: 0.1rem;
        &.active {
          animation: flashing 0.8s ease;
        }
      }
    }
  }
  @keyframes flashing {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
}
</style>
